import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';

import FeedsCarousel from '../index';
import useFeedsCarousel from '../useFeedsCarousel';

import ChevronIcon from './icons/DoubleChevron';
import styles from './index.css';


const FeedsCarouselDesktopWrapper: FC = () => {
  const { realityShow } = ProfileStore;
  const { isEventCarouselOpen, setShowEventCarousel } = UserStore;

  const { streams } = useFeedsCarousel();

  const isMainEvent = Boolean(realityShow?.mainEvent);

  const onToggle = useCallback(() => {
    setShowEventCarousel(!isEventCarouselOpen);
  }, [isEventCarouselOpen, setShowEventCarousel]);


  if (!isMainEvent || !streams.length) {
    return null;
  }

  const iconClasses = {
    [styles.toggleIcon]: true,
    [styles.isClosed]: !isEventCarouselOpen,
  };

  const className = {
    [styles.wrapper]: true,
    [styles.visible]: isEventCarouselOpen,
  };

  return (
    <div className={classNames(className)}>
      <button
        className={styles.toggleButton}
        onClick={onToggle}
      >
        <ChevronIcon className={classNames(iconClasses)} />
      </button>

      <div className={styles.container}>
        <FeedsCarousel streams={streams} />
      </div>
    </div>
  );
};

export default observer(FeedsCarouselDesktopWrapper);
